import React, { useState, useEffect, useContext } from "react"
import { useNavigate, useParams } from "react-router-dom"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import { fnIsObserver, fnIsResponsible } from "../../../utils/permissions"
import PaineisContext from "../../../contexts/Paineis"
import PainelIcon from "../../../assets/icons/PainelIcon"
import Container from "../../atoms/Container"
import ContentBlank from "../../molecules/ContentBlank"
import RcmpCardBoard from "../../organisms/CardBoard"
import TabsSelectedPanels from "../../organisms/TabsSelectedPanels"
import useDataApi from "../../../hooks/useDataApi"
import {
  fnGetBoards,
  fnGetBoard,
  fnCreateBoard,
  fnDeleteBoard,
  fnUpdateBoard,
  fnMoveBoard,
  fnDuplicateBoard,
} from "../../../services/boards"
import { getPaineis } from "../../../services/paineis"
import InfiniteScroll from "../../atoms/InfiniteScroll"
import RcmpAddCard from "../../molecules/AddCard"
import RcmpLoading from "../../atoms/Loading"
import RcmpEmptyContentPage from "../../molecules/EmptyContentPage"
import imgfNoBoards from "../../../assets/img/no-boards-illustration.svg"

import AZFilterIcon from "../../../assets/icons/AZFilterIcon"
import ZAFilterIcon from "../../../assets/icons/ZAFilterIcon"
import MembersIcon from "../../../assets/icons/MembersIcon"
import EarlyFilterIcon from "../../../assets/icons/EarlyFilterIcon"
import LateFilterIcon from "../../../assets/icons/LateFilterIcon"
import AuthContext from "../../../contexts/Auth"
import { searchHighlight } from "../../../utils/search"
import StatesOfModals from "../../../contexts/StatesOfModals"
import RcmpModalsBoardChange from "../../organisms/ModalsBoardsChange/RcmpModalsBoardsChange"
import RcmpHeader from "../../atoms/Header"
import usePanelMenu from "../../../hooks/usePanelMenu"
import RcmpModalsPanel from "../../organisms/ModalsPanel"
import BoardContext from "../../../contexts/Board"
import useCheckSubmitRegister from "../../../hooks/useCheckSubmitRegister"
import { FilterContext } from "../../../contexts/Filter"
import { toast } from "@stardust-ds/react"
import RcmpModalCreateNewBoard from "../../organisms/ModalCreateNewBoard"
import ModalShowDetail from "../../organisms/ModalCreateNewBoard/ModalShowDetail"

const orderParams = {
  "A-Z": `&order=name&direction=ASC`,
  "Z-A": `&order=name&direction=DESC`,
  responsibles: `&order=responsibles&direction=ASC`,
  members: `&order=observers&direction=ASC`,
  early: `&order=created_at&direction=DESC`,
  late: `&order=created_at&direction=ASC`,
}

export default function QuadrosPage() {
  const [aBoardData, fnSetABoadData] = useState([])
  const [bIsResponsible, fnSetBIsResponsible] = useState(false)
  const [oBoardDataMove, fnSetOBoardDataMove] = useState({})
  const [aCards, fnSetAcards] = useState([])
  const [nCardId, fnSetNCardId] = useState(undefined)
  const [cNameBoard, fnSetCName] = useState("undefined")
  const [oParams, fnSetOparams] = useState({ cSearchTerm: "", cOrder: "early" })
  const { oUser } = useContext(AuthContext)
  const {
    fnOpenModalEditBoard,
    bIsOpenModalEditBoard,
    bIsOpenModalAddBoard,
    fnCloseModalAddBoard,
    fnOpenModalAddBoard,
    fnCloseModalEditBoard,
    fnOpenModalAlertDeleteBoard,
    fnOpenModalDeleteBoard,
    fnCloseModalDeleteBoard,
    bIsOpenModalDeleteBoard,
    bIsOpenModalDeleteBoardAlert,
    bIsOpenModalInteractionsBoard,
    fnSetBIsOpenModalInteractionsBoard,
    bIsOpenModalMoveBoard,
    fnSetIsOpenModalMoveBoard,
    fnSetIsOpenModalMoveAlertBoard,
    bIsOpenModalMoveAlertBoard,
    closeModalMoveAlert,
    fnGetNormsSubmit,
    fnHandleModalMoveAlert,
    fnOpenCreateFromZeroModal,
    fnCloseCreateFromZeroModal,
    bIsOpenModalCreateNoModelBoard,
    bIsOpenModalShowDetails,
    fnOpenModalShowDetails,
    fnCloseModalShowDetails,
    fnCompleteModalShowDetails,
    aNorms,
    schema,
  } = useContext(StatesOfModals)

  const { selectedPaineis } = useContext(PaineisContext)
  const { fnCleanUpFilters } = useContext(FilterContext)
  const { fnSetOCurrentBoard, oCurrentBoard } = useContext(BoardContext)
  const [oBoards, fnFetchBoards] = useDataApi(fnGetBoards)
  const [oBoard, fnFetchBoard] = useDataApi(fnGetBoard)
  const [oCreateBoard, fnSubmitCreateBoard] = useDataApi(fnCreateBoard)
  const [oDeleteBoard, fnSubmitDeleteBoard] = useDataApi(fnDeleteBoard)
  const [oUpdateBoard, fnSubmitUpdateBoard] = useDataApi(fnUpdateBoard)
  const [oDuplicateBoardRes, fnSubmitDuplicateBoardReq] = useDataApi(fnDuplicateBoard)
  const [oMoveBoard, fnSubmitMoveBoard, fnResetBoardMove] = useDataApi(fnMoveBoard)
  const [oGetPaineis, fnSubmitGetPaineis] = useDataApi(getPaineis)
  const [bIsOpenModalDuplicate, fnSetBIsOpenModalDuplicate] = useState(false)
  const [bIsOpenModalExport, fnSetBiSOpenModalExport] = useState(false)
  const [oSelectedModel, setSelectedModel] = useState(null)

  const [fnCheckRegister] = useCheckSubmitRegister()

  const fnNavigate = useNavigate()
  const { panelId } = useParams()

  const aPanelMenuOptions = usePanelMenu()

  const fnToDashBoardPage = () => fnNavigate("/")

  const fetchBoardsWithParams = async (page) => {
    if (oBoards?.loading || !panelId) return
    const perPage = 12
    const orderParam = orderParams[oParams.cOrder] || orderParams["early"]
    const response = await fnFetchBoards(
      panelId,
      `perPage=${perPage}&page=${page}&search=${oParams.cSearchTerm}${orderParam}`,
    )

    if (page <= 1) {
      fnSetAcards(response?.data?.data || [])
      return
    }

    fnSetAcards([...aCards, ...(response?.data?.data || [])])
  }

  async function fetchBordData(id) {
    const response = await fnFetchBoard(panelId, id)
    await fnSetABoadData(response?.data?.data)
    await fnGetNormsSubmit()
    aBoardData && fnOpenModalEditBoard()
  }

  const fnOnSelectPanel = (oPanel) => {
    fnNavigate(`/${oPanel.value}/boards`)
  }
  const cActionMessage = bIsResponsible ? intl.get("BlocksPage.action_message") : ""

  const nextPage = async (page) => {
    await fetchBoardsWithParams(page)
  }

  useEffect(() => {
    fnCleanUpFilters()
  }, [])

  useEffect(() => {
    ;(async () => {
      fnSetAcards([])
      await fetchBoardsWithParams(1)
    })()
  }, [panelId, oParams])

  useEffect(() => {
    if (!aCards?.length) return
    searchHighlight(oParams.cSearchTerm)
  }, [oParams, aCards])

  useEffect(() => {
    if (!oDeleteBoard.done || !oDeleteBoard.data) return
    ;(async () => {
      fnSetAcards([])
      await fetchBoardsWithParams(1)
    })()
  }, [oDeleteBoard])

  useEffect(() => {
    if (!oMoveBoard.done && !oMoveBoard.data?.length) return
    ;(async () => {
      fnSetAcards([])
      await fetchBoardsWithParams(1)
      fnResetBoardMove()
    })()
  }, [oMoveBoard])

  useEffect(() => {
    if (!oUpdateBoard.done && !oUpdateBoard.data?.length) return
    ;(async () => {
      fnSetAcards([])
      await fetchBoardsWithParams(1)
    })()
  }, [oUpdateBoard])

  useEffect(() => {
    if (!oCreateBoard.done && !oCreateBoard.data?.length) return
    ;(async () => {
      fnSetAcards([])
      await fetchBoardsWithParams(1)
    })()
  }, [oCreateBoard])

  useEffect(() => {
    if (!oDuplicateBoardRes.done && !oDuplicateBoardRes?.data?.length) return
    ;(async () => {
      fnSetAcards([])
      await fetchBoardsWithParams(1)
    })()
  }, [oDuplicateBoardRes])

  const fnOnChangeSearchTerm = (cSearchTerm) => {
    fnSetOparams((prev) => ({ ...prev, cSearchTerm }))
  }

  const fnOnChangeOrder = (cOrder) => {
    fnSetOparams((prev) => ({ ...prev, cOrder }))
  }

  function fnHandleCancel() {
    fnCloseModalEditBoard()
  }

  function fnToastFail() {
    return toast({
      type: "error",
      title: intl.get("table_fields.toast.fail"),
      description: intl.get("CardBoard.modal.toast_message_error"),
    })
  }

  const oCurrentPanel = selectedPaineis?.find((p) => String(p?.id) === panelId)

  const oSelectedPanel = {
    ...oCurrentPanel,
    value: oCurrentPanel?.id,
    label: oCurrentPanel?.name,
  }

  const oSelectedBoard = aCards?.find((c) => c.id === nCardId)

  useEffect(() => {
    const bResponsible = fnIsResponsible(
      oUser?.data?.user_nid,
      oCurrentPanel?.responsibles,
      aCards,
    )
    fnSetBIsResponsible(bResponsible)
  }, [oUser, panelId])

  async function fnHandleCreateBoard(data) {
    const response = await fnSubmitCreateBoard(panelId, data)
    if (response.success) {
      fnSetOCurrentBoard(response?.data)
      fnNavigate(`/${panelId}/boards/${response.data.id}/new-board`, { replace: true })
    }
    fnCloseCreateFromZeroModal()
  }

  async function fnCheckBoard(cErrorMessage) {
    const oCheckRegister = {
      nBoardId: nCardId,
      nPanelId: panelId,
    }

    return await fnCheckRegister(oCheckRegister, cErrorMessage)
  }

  async function fnHandleDeleteBoardSubmit(data) {
    const bCanSubmit = await fnCheckBoard(intl.get("BoardsPage.delete_board_error"))
    if (!bCanSubmit) {
      fnCloseModalDeleteBoard()
      return
    }

    return await fnSubmitDeleteBoard(nCardId, data)
  }

  async function fnHandleUpdateBoardSubmit(data) {
    await fnSubmitUpdateBoard(nCardId, data)
  }

  async function fnHandleAddModalOpen() {
    fnOpenModalAddBoard()
    await fnGetNormsSubmit()
  }

  const fnCanChangeBoard = bIsResponsible ? fnHandleAddModalOpen : null

  async function fnHandleModalMoveOpen() {
    const response = await fnSubmitGetPaineis("perPage=200")
    response.success && fnSetIsOpenModalMoveBoard(true)
  }

  function fnCloseModaMoveBoard() {
    fnSetIsOpenModalMoveBoard(false)
  }

  async function fnMoveBoardSubmit() {
    const response = await fnFetchBoard(Number(panelId), nCardId)
    if (response?.data?.data?.length) {
      await fnSubmitMoveBoard(response?.data?.data[0], oBoardDataMove.id)
    }

    fnSetIsOpenModalMoveAlertBoard(false)
  }

  function fnHandleObserver(oBoard) {
    if (bIsResponsible) return false

    const nUserId = oUser?.data?.user_nid
    const bIsObserver = fnIsObserver(nUserId, oBoard?.observers)
    return bIsObserver
  }

  function fnSelectBoard(board) {
    fnSetOCurrentBoard(board)
    const bBoardObserver = fnHandleObserver(board)
    fnNavigate(`/${panelId}/boards/${board.id}`, {
      state: { cBoardName: board.name, bBoardObserver },
    })
  }
  function fnGetDataBoardDelete(id, name) {
    fnSetNCardId(id)
    fnSetCName(name)
  }

  function fnOpenModalDuplicateBoard(data) {
    fnSetOCurrentBoard(data)
    fnSetBIsOpenModalDuplicate(true)
  }

  function fnOnCloseDuplicateModal() {
    fnSetBIsOpenModalDuplicate(false)
  }

  function fnOnCloseModalExport() {
    fnSetBiSOpenModalExport(false)
  }

  async function fnHandleConfirmDuplicateBoard(e) {
    e.stopPropagation()
    e.preventDefault()
    const response = await fnSubmitDuplicateBoardReq(oCurrentBoard?.id)
    if (response.success) {
      fnSetBIsOpenModalDuplicate(false)
      return
    }
    fnSetBIsOpenModalDuplicate(false)
    fnToastFail()
  }

  const aOrderOptions = [
    {
      label: intl.get("DashboardPage.a_z_by_title"),
      value: "A-Z",
      icon: <AZFilterIcon />,
    },
    {
      label: intl.get("DashboardPage.z_a_by_title"),
      value: "Z-A",
      icon: <ZAFilterIcon />,
    },
    {
      label: intl.get("BoardsPage.responsibles"),
      value: "responsibles",
      icon: <MembersIcon />,
    },
    {
      label: intl.get("BoardsPage.observers"),
      value: "members",
      icon: <MembersIcon />,
    },
    {
      label: intl.get("DashboardPage.most_recent"),
      value: "early",
      icon: <EarlyFilterIcon />,
    },
    {
      label: intl.get("DashboardPage.older"),
      value: "late",
      icon: <LateFilterIcon />,
    },
  ]

  const aBreadCrumbs = [
    {
      path: "./",
      name: intl.get("home"),
    },
    {
      path: "/",
      name: intl.get("DashboardPage.title"),
    },
    {
      name: oCurrentPanel?.name,
      bActive: true,
    },
  ]

  return (
    <>
      <RcmpHeader
        cTitlePage={intl.get("BoardsPage.title")}
        aBreadCrumbs={aBreadCrumbs}
        className={styles.hideHeaderTitle}
      >
        <div className={styles.selectPaineisContainer}>
          <div className={styles.painelIconContainer} onClick={fnToDashBoardPage}>
            <PainelIcon />
          </div>
          <TabsSelectedPanels
            oSelectTab={oSelectedPanel}
            fnOnSelectPanel={fnOnSelectPanel}
          />
        </div>
      </RcmpHeader>
      <div className={styles.quadrosContainer}>
        <ContentBlank
          fnSetBisOpenModal={fnCanChangeBoard}
          setSearchTerm={fnOnChangeSearchTerm}
          onChangeOrder={fnOnChangeOrder}
          selectedOrder={oParams.cOrder}
          cLabelDescription={intl.get("BoardsPage.panel_description")}
          cDescription={oCurrentPanel?.description}
          aOrderOptions={aOrderOptions}
          sButtonLabel={intl.get("BoardsPage.new_board")}
          aEllipsisContent={aPanelMenuOptions}
          bCanChange={bIsResponsible}
        >
          <InfiniteScroll
            fnNext={nextPage}
            nTotalPages={oBoards?.data?.data?.last_page}
            nDataLength={aCards.length}
            bStopPagination={oBoards?.error || oBoards?.loading}
          >
            <Container className={styles.boardsList}>
              {aCards?.map((oBoard) => (
                <RcmpCardBoard
                  key={oBoard.id}
                  fnSetNCardId={fnGetDataBoardDelete}
                  oBoard={oBoard}
                  onClick={fnSelectBoard}
                  fnSetBDelete={fnOpenModalAlertDeleteBoard}
                  fetchBordData={fetchBordData}
                  fnSetBOpenInteractions={fnSetBIsOpenModalInteractionsBoard}
                  cReadOnlyMessage={intl.get("BoardsPage.board_read_only_message")}
                  bReadOnly={fnHandleObserver(oBoard)}
                  fnSetBisMove={fnHandleModalMoveOpen}
                  bIsResponsible={bIsResponsible}
                  fnSetBDuplicateBoard={fnOpenModalDuplicateBoard}
                  bIsOpenModalExport={bIsOpenModalExport}
                  fnSetBiSOpenModalExport={fnSetBiSOpenModalExport}
                  fnSetBoard={fnSetOCurrentBoard}
                />
              ))}
              {aCards?.length > 0 && fnCanChangeBoard && (
                <RcmpAddCard
                  onClick={fnHandleAddModalOpen}
                  cLabel={intl.get("BoardsPage.new_board")}
                  bLarge
                />
              )}
            </Container>
          </InfiniteScroll>
          <RcmpEmptyContentPage
            bShow={!oBoards?.loading && !aCards?.length}
            cMessage={
              oParams?.cSearchTerm?.length
                ? intl.get("BoardsPage.no_search_board_panel")
                : intl.get("BoardsPage.no_board_panel")
            }
            cActionMessage={cActionMessage}
            fnOnAction={fnHandleAddModalOpen}
            cQuestion={intl.get("BoardsPage.what_is_a_board")}
            cAnswer={intl.get("BoardsPage.board_answer")}
            image={imgfNoBoards}
          />
          <RcmpLoading bShow={oBoards?.loading} />

          <RcmpModalsBoardChange
            ///////////create and edit modal
            fnHandleCancel={fnCloseCreateFromZeroModal /* fnHandleCancel */}
            nCardId={nCardId}
            aNorms={aNorms}
            bIsOpen={bIsOpenModalCreateNoModelBoard}
            fnHandleUpdateBoardSubmit={fnHandleUpdateBoardSubmit}
            bIsEdit={bIsOpenModalEditBoard}
            fnHandleCreateBoard={fnHandleCreateBoard}
            schema={schema}
            aBoardData={aBoardData}
            fnSetABoadData={fnSetABoadData}
            ///////////delete
            fnSetBDeleteBoardConfirmation={fnCloseModalDeleteBoard}
            fnHandleDeleteBoardSubmit={fnHandleDeleteBoardSubmit}
            bDeleteBoardConfirmation={bIsOpenModalDeleteBoard}
            bDeleteBoard={bIsOpenModalDeleteBoardAlert}
            cNameBoard={cNameBoard}
            ///////delete alert
            fnHandleDeleteBoardCancel={fnCloseModalDeleteBoard}
            fnHandleDeleteBoard={fnOpenModalDeleteBoard}
            ////interaction
            bOpenInteractions={bIsOpenModalInteractionsBoard}
            fnSetBOpenInteractions={fnSetBIsOpenModalInteractionsBoard}
            oSelectedBoard={oSelectedBoard}
            ///Move
            bIsMove={bIsOpenModalMoveBoard}
            fnCloseModaMoveBoard={fnCloseModaMoveBoard}
            oGetPaineis={oGetPaineis?.data?.data?.data}
            panelId={panelId}
            fnHandleModalInfo={fnHandleModalMoveAlert}
            fnSetOBoardDataMove={fnSetOBoardDataMove}
            /// move alert modal
            bModalInfo={bIsOpenModalMoveAlertBoard}
            fnSetBModalInfo={closeModalMoveAlert}
            fnMoveBoardSubmit={fnMoveBoardSubmit}
            oCurrentPanel={oCurrentPanel}
            oCurrentBoard={oCurrentBoard}
            oBoardDataMove={oBoardDataMove}
            //duplicate modal
            fnOnCloseDuplicateModal={fnOnCloseDuplicateModal}
            bIsOpenDubplicate={bIsOpenModalDuplicate}
            fnHandleConfirmDuplicateBoard={fnHandleConfirmDuplicateBoard}
            // export board
            bIsOpenModalExport={bIsOpenModalExport}
            fnOnCloseModalExport={fnOnCloseModalExport}
          />
          <RcmpModalsPanel />
          <RcmpModalCreateNewBoard
            isOpen={bIsOpenModalAddBoard}
            onClose={fnCloseModalAddBoard}
            fnCreateNoModel={fnOpenCreateFromZeroModal}
            fnOpenShowDetail={fnOpenModalShowDetails}
            fnHandleSelectModel={setSelectedModel}
            fetchBoards={fetchBoardsWithParams}
          />
          <ModalShowDetail
            isOpen={bIsOpenModalShowDetails}
            onClose={fnCloseModalShowDetails}
            completeClose={fnCompleteModalShowDetails}
            data={oSelectedModel}
            fetchBoards={fetchBoardsWithParams}
          />
        </ContentBlank>
      </div>
    </>
  )
}
